export const withCurrentUserFirst = ({ currentUserId, users }) => [
  ...users.filter((u) => u.id === currentUserId),
  ...users.filter((u) => u.id !== currentUserId),
];
